(function () {
  var NS = 'http://www.w3.org/2000/svg';
  function el(tag, attrs) { var e = document.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); return e; }

  function init(root) {
    if (root.__mh) return; root.__mh = true;
    var centEl = root.querySelector('.mh-cent'), gPins = root.querySelector('.mh-pins');
    if (!centEl || !gPins) return;
    var CENT = JSON.parse(centEl.textContent);

    // nº de centros por provincia (data-provs = "Girona|Girona|Madrid|...")
    var count = {};
    (root.getAttribute('data-provs') || '').split('|').forEach(function (p) { if (CENT[p]) count[p] = (count[p] || 0) + 1; });
    // 3 tamaños, sin cifras (para ver el detalle hay que entrar al mapa): 1 centro / 2-10 / más de 10
    function radio(n) { return n > 10 ? 22 : (n > 1 ? 15 : 9); }

    // de más a menos centros: los grandes se dibujan debajo y aparecen primero
    Object.keys(count).sort(function (a, b) { return count[b] - count[a]; }).forEach(function (p, i) {
      var n = count[p], r = radio(n);
      // posición en el <g> exterior; la animación CSS va en el interior (si no, el transform CSS pisa el translate)
      var pos = el('g', { transform: 'translate(' + CENT[p][0] + ',' + CENT[p][1] + ')' });
      var g = el('g', { 'class': 'mh-pin' });
      g.style.transitionDelay = (i * 70) + 'ms';
      pos.appendChild(g);
      var ring = el('circle', { 'class': 'mh-ring', r: r });
      ring.style.animationDelay = (i * 160) + 'ms';
      g.appendChild(ring);
      g.appendChild(el('circle', { r: r }));
      var tip = el('title', {}); tip.textContent = p.split('/').pop(); g.appendChild(tip);
      gPins.appendChild(pos);
    });

    // los pines caen al entrar la sección en pantalla
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { root.classList.add('is-in'); io.disconnect(); } });
      }, { threshold: 0.3 });
      io.observe(root);
    } else { root.classList.add('is-in'); }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.mapa-home'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
